/**
 * Frequently Asked Questions (FAQ) - Archive (listing view)
 */

'use strict';

var ui = require('../misc/layout');

// Constructor
var FrontFaqShortcode = function () {
    if (!$('.shortcode-cm-faq').length > 0) {
        return;
    }

    $(document).ready((function () {
        this.initCollapsible();
    }).bind(this));
};

FrontFaqShortcode.prototype = {
    /**
     * Initialize the Collapsible Materialize component.
     */
    initCollapsible: function() {
        ui.initCollapsible();
    },
};

module.exports = new FrontFaqShortcode();
